import React from "react";
import { useNavigate } from "react-router-dom";

function Navbar() {
   const handleToggle = () => {
    document.body.classList.toggle('sidebar-icon-only');
  };
    const navigate = useNavigate();
 const movetologin = (e) => {
  e.preventDefault();
  const items = document.querySelectorAll("li.nav-item");
  items.forEach((item) => item.classList.remove("active"));
  e.currentTarget.classList.add("active");
  sessionStorage.clear();
  
    navigate("/");
  };
  const movetodashboard = () => {
    const items = document.querySelectorAll("li.nav-item");
    items.forEach((item) => item.classList.remove("active"));
    navigate("/dashboard");
  }
  
  return (
    <>
      <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center">
          <a class="navbar-brand brand-logo" href="#"  onClick={(e) => {
                                e.preventDefault();
                                movetodashboard();
                              }}>
            <img
              src="../assets/images/jac-academic-council.png"
              class="me-2"
              alt="logo"
            />
          </a>
          <h5 class="mt-3">Jharkhand Academic Council</h5>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
          <button
            className="navbar-toggler navbar-toggler align-self-center"
            type="button"
            onClick={handleToggle}
          >
            <span className="icon-menu"></span>
          </button>
          <span
            style={{
              marginLeft: "15px",
              fontWeight: "600",
              fontSize: "18px",
              marginTop: "5px",
            }}
            class="text-danger"
          >
           Scrutiny Portal - 2026 ( Class XII )
          </span>
          <ul class="navbar-nav navbar-nav-right">
            <li class="nav-item nav-profile dropdown">
              <a class="dropdown-item logout" href="#" onClick={(e) => movetologin(e)}>
                <i class="ti-power-off text-primary"></i> Logout{" "}
              </a>
            </li>
          </ul>
          <button
            class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
          >
            <span class="icon-menu"></span>
          </button>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
